import FieldWeightController from './FieldWeightController'

export default FieldWeightController
